import { convertNodeToElement } from 'react-html-parser'

export function transformParagraphToSpan(node, index) {
  const { type, name } = node
  if (type === 'tag' && name === 'p')
    return convertNodeToElement({ ...node, name: 'span' }, index)
}
